export default __webpack_public_path__ + "static/isneesh-c43cd765707a86b8ad808f1a040949cd.png";